import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    offset: { type: Number, default: 0 }
  }

  scrollTo(event) {
    event.preventDefault()

    const link = event.currentTarget
    const id = link.hash.substring(1) // #を除いたIDを取得
    const targetElement = document.getElementById(id)

    if (targetElement) {
      const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY
      const offsetPosition = elementPosition - this.offsetValue

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      })

      // URLのハッシュを更新 (オプション)
      // スクロール後にハッシュを更新したい場合
      // history.pushState(null, null, link.hash)
      // もしURLを変更したくない場合は上記の行をコメントアウトまたは削除
    } else {
      console.warn(`Smooth scroll target not found: #${id}`)
      // ターゲットが見つからない場合、通常のリンク遷移を許可する（オプション）
      // window.location.href = link.href;
    }
  }
}
